'use client';

import CheckSvg from '@/assets/svgs/color-circle-check.svg';
import UncheckSvg from '@/assets/svgs/uncheck.svg';
import { inter600 } from '@/config/fonts';
import { showNumberOfItemsInColumnMapping } from '@/shared/utils/contact-list';
import classNames from 'classnames';
import { ColumnData } from '../types';

interface SelectColumnForFieldProps {
  columnData: ColumnData;
  className?: string;
  selected?: boolean;
  onSelect: (column: ColumnData) => void;
  selectionStyle?: 'checkbox' | 'overlay';
}

const SelectColumnForField = ({
  columnData,
  className,
  onSelect,
  selected: isSelected,
  selectionStyle = 'checkbox',
}: SelectColumnForFieldProps) => {
  const { data, columnNumber } = columnData;
  const items = data ?? [];
  return (
    <div
      className={classNames(
        'group bg-base-100 dark:bg-base-200 relative h-60 w-60 cursor-pointer overflow-hidden rounded-xl border-[1px] border-gray-200 p-[3px] dark:border-gray-700',
        {
          '!border-primary dark:bg-primary/20 !border-2 bg-blue-100 !p-[2px] shadow-[rgba(0,0,0,0.14)_0_20px_25px_-5px]':
            isSelected,
          'hover:!border-black-300': selectionStyle === 'overlay',
        },
        className
      )}
      onClick={() => {
        onSelect(columnData);
      }}>
      {selectionStyle === 'overlay' && (
        <>
          <div className="absolute top-0 right-0 bottom-0 left-0 hidden items-center justify-center bg-[rgba(0,0,0,0.12)] group-hover:flex">
            <button
              type="button"
              className="btn btn-sm bg-base-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600">
              Select
            </button>
          </div>
        </>
      )}
      <div
        className={classNames(
          'column-header text-primary flex h-8 items-center justify-between rounded-t-lg rounded-b-sm px-3 text-sm dark:border-gray-700 dark:text-gray-400',
          {
            'bg-gray-100 dark:bg-transparent': !isSelected,
            'dark:bg-primary/20 bg-blue-200': isSelected,
          },
          inter600.className
        )}
        tabIndex={1}>
        <span>Col {columnNumber}</span>
        {selectionStyle === 'checkbox' && (
          <>
            {isSelected ? (
              <CheckSvg className="text-primary h-5 w-5" />
            ) : (
              <UncheckSvg className="fill-base-100 stroke-gray-300 stroke-2" />
            )}
          </>
        )}
      </div>

      <div className="items pt-1">
        {items?.slice(0, showNumberOfItemsInColumnMapping).map((item, idx) => {
          return (
            <div key={idx} className="flex h-8 items-center gap-[21px] pl-3 text-sm">
              <span>{idx + 1}</span>
              <span
                title={item}
                className="overflow-hidden text-ellipsis whitespace-nowrap">
                {item}
              </span>
            </div>
          );
        })}
        {items.length > showNumberOfItemsInColumnMapping && (
          <div className="flex h-8 items-center gap-[21px] pl-3 text-sm">
            +{items.length - showNumberOfItemsInColumnMapping} more
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectColumnForField;
